<template>
  <div class="">
    <NfcModal :modalId="'nfc-modal'" :user="this.selectedUser"/>
    <cardView :title="$t('admin.users.userManagement')">
      <div class="mb-3 p-0">
        <b-row class="mb-4 pr-3 pt-0">
          <b-col cols="1" sm="auto" class="ml-auto">
            <Button class="w-100 h-2 mb-2 mt-2 ml-3 pl-3 pr-3"
              @frameworkButtonClicked="$router.push({ name: 'admin-usermanagement-create' })"
              :color="getColors.defaultColorSolidButton" :backgroundColor="getColors.defaultBackgroundColorSolidButton"
              :fontSize="'15px'" :fontWeight="'600'" :outline="true" :size="'small'" :display="'inline'"
              :width="'calc(100% - 5px)'" :padding="'2px 0'">
              <template #button-content>
                <span>{{ $t('admin.users.createUser') }} <i class="far fa-plus"></i></span>
              </template>
            </Button>
          </b-col>
        </b-row>
        <b-row>
          <b-col right class="mb-2">
            <input type="string" class="form-control" v-model="searchInput"
              :placeholder="$t('userSwitcher.search')+'...'">
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <UserTable :users="filteredData" @show-modal="showModal" @renderEvent="renderUsers"/>
          </b-col>
        </b-row>
      </div>
    </cardView>
  </div>
</template>

<script>
import colors from "@/assets/scss/MotivateColors.scss";
import Button from "@/components/ui/Button.vue";

import { mapGetters } from 'vuex';
import { dataTables } from '@/mixins/dataTables';

import firebase from "firebase/app";

import CardView from "@/components/cardView.vue";
import UserTable from "../../../components/userManagement/userTable.vue";
import NfcModal from "../../../components/userManagement/nfcModal.vue";

export default {
  name: 'Usermanagement',
  components: { CardView, Button, UserTable, NfcModal },
  mixins: [dataTables],
  data() {
    return {
      companies: [],
      usersData: [],
      customFilters: [],
      nfcModalOpen: false,
      nfcId: null,
      selectedUser: null,
      scanResponse: {
        error: null,
        message: null
      },
      searchInput: '',

    };
  },
  firestore() {
    return {
      companies: this.$FB.collection('companies')
    };
  },
  computed: {
    ...mapGetters('users', [
      'getClaims',
    ]),
    getColors() {
      return colors
    },
    getTableOptions() {
      let options = _.omit(this.tableInitOptions, ['buttons', 'dom'])

      return options
    },
    claims() {
      return this.$FirebaseAuth.getClaims();
    },
    shouldRender() {
      return this.usersData.length && this.companies.length > 0
    },
    filteredData() {
      return this.usersData.filter(user => {
        const matchesSearch =
          (user.displayName && user.displayName.toLowerCase().includes(this.searchInput.toLowerCase())) ||
          (user.email && user.email.toLowerCase().includes(this.searchInput.toLowerCase()))
        return matchesSearch
      });
    }
  },
  methods: {
    showModal(user){
      this.selectedUser = user
      window.$('#nfc-modal').data('parameters', {
      })
      window.$('#nfc-modal').modal('show') 
    },
    async renderUsers(){
      let usersDataGetAll = await this.$FUNCTIONS.Users('getAllUsers')
      let newUsers = []
      this.usersData = _.each(usersDataGetAll.data, async user => {
        let userData = await this.$FB.collection('userData').doc(user.uid).get()
        let nfcEnabled = !!userData.get('nfcId');
        let imgUrl
        if (user.photoURL && user.photoURL.length) {
          imgUrl = await firebase
            .storage()
            .ref("users/" + user.uid + "/profile.jpg")
            .getDownloadURL()
        } else {
          imgUrl = null
        }
        let photo = imgUrl
        newUsers.push({ ...user, nfcId: nfcEnabled, photo })
      });
      this.usersData = newUsers
    }
  },
  async created() {
    this.$store.commit('setLoading', true);

    await this.renderUsers()
    this.$store.commit('setLoading', false);
  },
};
</script>
<style lang="scss" scoped>
@import "../../../assets/scss/MotivateColors";
@import "../../../assets/scss/workflowInterface/form.scss";
</style>
